import axios from 'axios';

import { SERVER_API_URL } from '@/constants';

const TIMEOUT = 1000000;
const onRequestSuccess = config => {
  const token = localStorage.getItem('jhi-authenticationToken') || sessionStorage.getItem('jhi-authenticationToken');
  const selectedOrg = localStorage.getItem('opus-default-org');
  
  if (token) {
    if (!config.headers) {
      config.headers = {};
    }
    if (!config.headers.Authorization){
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers.oid = selectedOrg;
  }
  config.timeout = TIMEOUT;
  config.url = `${SERVER_API_URL}${config.url}`;
  return config;
};
const setupAxiosInterceptors = onUnauthenticated => {
  const onResponseError = err => {
    if (err.message !== 'canceled') {
      const status = err.status || err.response.status;
      if (status === 403 || status === 401) {
        onUnauthenticated();
      }
    }
    return Promise.reject(err);
  };
  if (axios.interceptors) {
    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use(res => res, onResponseError);
  }
};

export { onRequestSuccess, setupAxiosInterceptors };
